<!-- page starts-->
    <section class="page-wrapper">
        <div class="ashton-hero-top-news-single-section cf" [ngStyle]="{'background-image':'url(' + newsImage + ')'}">
        	<div class="container">
                <div class="ashton-hero-top-news-single-detail">
            		<div class="date">
                       <p>{{newsSingle?.created_at | amDateFormat:'MMM DD, YYYY'}}</p>      
                    </div>
                </div>
        	</div>
        	<a [routerLink]="['/news-single', newsSingle?.is_previous]" class="Previous-player" *ngIf="newsSingle?.is_previous">
        		<p>Previous</p>
		    </a>
		    <a [routerLink]="['/news-single', newsSingle?.is_next]" class="next-player" *ngIf=" newsSingle?.is_next">
		    	<p>Next</p>
		    </a>
        </div>
        <div class="ashton-hero-top-detail cf">
         <div class="container">
         	<div class="ashton-hero-top-news-single-about">
         	   <div class="red-titel">{{newsTitle}}</div>	
         	   <div class="ashton-hero-top-news-single-about-content" [innerHTML]="newsDesc">
         	   </div>
         	</div>
         </div>
        </div>
    </section><!-- page ends-->